<template>
  <div id="footer">
    <!-- <v-snackbar bottom :value="updateExists" :timeout="-1" dark>
      An update is available.
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="refreshApp" color="primary"
          >Update</v-btn
        >
      </template>
    </v-snackbar> -->

    <!-- <v-tooltip top
          v-if="syncedPendingProducts?.length > 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
      fab
      small
      fixed
      bottom
      left
                @click="$emit('openCloseCartDialog')"
                :color="isAnyDialogOpen ? 'white' : 'primary'"
      class="mb-3"
      style="z-index: 230;"
              >
              <v-badge
          :content="syncedPendingProducts.length"
          :value="syncedPendingProducts.length"
          color="secondary"
          overlap
          class="badge-black-text cart-badge-position"
        ></v-badge>
                <v-icon :color="isAnyDialogOpen ? 'primary' : ''">mdi-cart-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $i18n.t("products.shoppingCart") }}</span>
          </v-tooltip> -->

    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      x-small
      fixed
      bottom
      right
      color="primary"
      @click="$vuetify.goTo(0)"
      class="mb-7"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>

    <v-footer app>
      <span> &copy; {{ new Date().getFullYear() }} Juffrou Anri. </span>
      <v-btn
        class="mx-2"
        small
        text
        color="primary"
        dark
        @click="openDialogTermsAndConditions"
      >
        <span style="font-size: 1.1em"> TERMS &amp; CONDITIONS </span>
      </v-btn>
      <v-spacer></v-spacer>
      <span class="font-weight-bold text-caption">v2.3.76</span>

      <div class="text-center" v-if="showLegal">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small text color="primary" dark v-bind="attrs" v-on="on">
              Legal Information
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(doc, di) in docs" :key="di">
              <v-btn small text :to="doc.route">
                {{ doc.title }}
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-spacer></v-spacer>

      <!-- <v-menu top>
        <template #activator="menu">
          <v-tooltip top>
            <template #activator="tooltip">
              <v-btn v-on="{ ...menu.on, ...tooltip.on }" icon
                ><v-icon>mdi-translate</v-icon></v-btn
              >
            </template>

            <span>Change language</span>
          </v-tooltip>
        </template>

        <v-list v-for="(lang, i) in languages" :key="i">
          <v-list-item @click="changeVuetifyLang(lang.value)">
            <v-list-item-content>
              <v-list-item-title>{{ lang.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu> -->

      <!-- <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="changeVuetifyLang()">
            <v-icon>mdi-translate</v-icon>
          </v-btn>
        </template>
        <span>Change language</span>
      </v-tooltip> -->
      <v-btn
        href="https://www.go-app.co.za/app-development/"
        small
        text
        target="_blank"
        >Powered by go!App
      </v-btn>
      <!-- <v-btn icon @click="refreshApp" v-if="updateExists === true">
        <v-icon dense color="primary">mdi-refresh</v-icon>
      </v-btn> -->
      <cookie-law theme="blood-orange" class="mb-10">
        <v-row align="center" slot-scope="props">
          <v-col class="grow">
            This site uses cookies. By continuing to browse the site, you are
            agreeing to our use of cookies.
            <v-dialog v-model="cookieDialog" width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on" text>
                  Read More
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="primary--text">COOKIES POLICY</span>
                </v-card-title>
                <v-card-text>
                  <p>
                    Cookies are files stored in your browser and are used by
                    most websites to help personalise your web experience. Some
                    features of this website will not function if you do not
                    allow cookies or have cookies disabled.
                  </p>
                  <p>
                    For the best experience using this site, we recommend using
                    an up-to-date browser with JavaScript enabled and accept
                    cookies.
                  </p>
                  <h2 class="subtitle-1">OVERALL</h2>
                  <p>
                    This website makes use of essential session cookies to
                    provide you the visitor with a service. We have
                    automatically set a session cookie so you can use this
                    website and service. If you do not want this cookie set,
                    then please follow the link at the bottom of this page or
                    manually delete the session cookie at any time by following
                    the instructions in your browser. By continuing to use this
                    website you give implied consent that we can store other
                    cookies on your computer to provide you with this service.
                    We will store some third party cookies to provide us with
                    analytical data about who visits this website (anonymous
                    visitor data, we cannot personally identify you), how they
                    find us, and how long they use the site for. We do not use
                    any information to track you, or personally identify you, we
                    are only looking at summary data, always anonymous.
                  </p>
                  <p class="subtitle-2">Cookie information</p>
                  <h2 class="subtitle-1">SESSION COOKIE</h2>
                  <p>
                    We automatically set a session cookie in order for you to
                    use this website or service. This session cookie is
                    essential for the correct operation of this website and
                    service. If the session cookie is not available, you may not
                    be able to use some or all of the features of this website
                    or service.
                  </p>
                  <p>
                    The session cookie stores some basic information about your
                    current status such as whether you are logged in and
                    previous search information e.g. registration numbers and
                    filters.
                  </p>
                  <p>
                    A session cookie only lasts as long as your current browsing
                    session and is typically removed or deleted by your browser
                    when you stop using this website or service. You can
                    manually delete your session cookie at any time by following
                    the instructions in your browser.
                  </p>
                  <h2 class="subtitle-1">THIRD-PARTY COOKIES</h2>
                  <p>
                    This website makes use of Google Analytics. Google Analytics
                    sets a cookie which allows us to view anonymous visitor data
                    so we can improve this website or service to you. We
                    typically make use of the overall visitor counts, the search
                    parameters users used to find us and the amount of time a
                    user spent on the site. You can manually delete this cookie
                    at any time by following the instructions in your browser.
                  </p>
                  <h2 class="subtitle-1">BACKGROUND INFORMATION</h2>
                  <p>
                    The 2003 Regulations implemented a European Directive –
                    2002/58/EC – which is concerned with the protection of
                    privacy in the electronic communications sector. In 2009
                    this Directive was amended by Directive 2009/136/EC. This
                    included a change to Article 5(3) of the E-Privacy Directive
                    requiring consent for storage or access to information
                    stored on a subscriber or users terminal equipment – in
                    other words a requirement to obtain consent for cookies and
                    similar technologies.
                  </p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="cookieDialog = false">
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col class="shrink">
            <v-btn color="primary" @click="props.accept">I accept</v-btn>
          </v-col>
        </v-row>
      </cookie-law>
    </v-footer>

    <TermsAndConditionsDialog
      v-if="dialogTermsAndConditions"
      @closeDialogTermsAndConditions="closeDialogTermsAndConditions"
    />
  </div>
</template>

<script>
import update from "@/mixins/update";
import CookieLaw from "vue-cookie-law";
import TermsAndConditionsDialog from "@/core/services/TermsAndConditionsDialog.vue";
import { mapState } from "vuex";
// import { DataStore } from "aws-amplify";
// import { TeacherProfile } from "@/models";
import { API } from "aws-amplify";
import { updateTeacherProfile } from "@/graphql/mutations";

export default {
  name: "FooterComponent",
  components: { CookieLaw, TermsAndConditionsDialog },
  props: {
    showLegal: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [update],

  data: () => ({
    fab: false,
    isAnyDialogOpen: false,

    cookieDialog: false,
    dialogTermsAndConditions: false,

    languages: [
      { title: "Afrikaans", value: "af" },
      { title: "English", value: "en" },
    ],

    docs: [
      { title: "Terms & Conditions", route: "/legal/terms-conditions" },
      { title: "Terms of Use", route: "/legal/terms-of-use" },
      { title: "Cookie Policy", route: "/legal/cookie-policy" },
      { title: "Privacy Policy", route: "/legal/privacy-policy" },
      {
        title: "Modern Slavery Statement",
        route: "/legal/modern-slavery-statement",
      },
      { title: "Quality Statement", route: "/legal/quality-statement" },
      { title: "WEEE Regulations", route: "/legal/weee-regulations" },
    ],

    dialogCheckTrigger: 0, // A dummy state to force re-computation
  }),
  computed: {
    ...mapState({
      syncedTeacherProfileModel: (state) => state.syncedTeacherProfileModel,
      syncedPendingProducts: (state) => state.syncedPendingProducts,
    }),
  },
  mounted() {
    this.observeDialogChanges();
  },
  methods: {
    observeDialogChanges() {
      // Locate the Vuetify application container
      const vuetifyApp = document.querySelector('[data-app="true"]');
      if (!vuetifyApp) {
        console.warn("Vuetify application container not found!");
        return;
      }

      // Set up the MutationObserver
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === "childList") {
            // Check added nodes for dialog-related classes
            const addedDialogs = Array.from(mutation.addedNodes).some(
              (node) =>
                node.classList &&
                node.classList.contains("v-dialog__content--active"),
            );
            // Check removed nodes for dialog-related classes
            const removedDialogs = Array.from(mutation.removedNodes).some(
              (node) =>
                node.classList &&
                node.classList.contains("v-dialog__content--active"),
            );

            // If a dialog was added or removed, handle the change
            if (addedDialogs || removedDialogs) {
              // console.log("Dialog state changed:", document.querySelector(".v-dialog__content--active") ? "Open" : "Closed");
              this.isAnyDialogOpen = document.querySelector(
                ".v-dialog__content--active",
              )
                ? true
                : false;
              break; // Exit loop once a change is detected
            }
          }
        }
      });

      // Observe changes in the Vuetify container
      observer.observe(vuetifyApp, {
        childList: true, // Watch for additions/removals of child elements
        subtree: false, // Include all nested elements (dialogs may be deep within the structure)
      });

      // Cleanup observer on component destroy
      this.$once("hook:beforeDestroy", () => {
        observer.disconnect();
      });
    },

    openDialogTermsAndConditions() {
      this.dialogTermsAndConditions = true;
    },
    closeDialogTermsAndConditions() {
      this.dialogTermsAndConditions = false;
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.scrollY || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    async changeVuetifyLang(langValue) {
      console.log("langValue:", langValue);
      console.log("Changing language:", this.$vuetify.lang.current);
      // const newLang = this.$vuetify.lang.current === "en" ? "af" : "en";
      const newLang = langValue;
      this.$vuetify.lang.current = newLang;
      this.$i18n.locale = newLang;
      console.log("Changed language:", this.$vuetify.lang.current);

      if (!this.syncedTeacherProfileModel) {
        return;
      }

      await API.graphql({
        query: updateTeacherProfile,
        variables: {
          input: {
            id: this.syncedTeacherProfileModel.id,
            _version: this.syncedTeacherProfileModel._version,
            translateI18n: newLang,
          },
        },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });

      // await DataStore.save(
      //   TeacherProfile.copyOf(
      //     this.syncedTeacherProfileModel,
      //     (updatedModel) => {
      //       updatedModel.translateI18n = newLang;
      //     },
      //   ),
      // );
    },
  },
};
</script>

<style>
.cart-badge-position {
  position: fixed;
  bottom: 68px;
  left: 56px;
}
</style>
